import { DateTime } from 'luxon';
import { TEmVatCorrectionsImportRow } from 'redux/reducers/emVatCorrectionsImport/types';
import { correctionPeriodLabel } from 'components/EmVatCorrections/tableStructure';

const SCHEME_LABELS: Record<string, string> = {
	ioss: 'IOSS',
	non_eu_ioss: 'Non EU IOSS',
	non_union: 'Non-Union',
	union: 'Union',
};

export const formatCorrectionDateTime = (iso: string | null | undefined): string | null => {
	if (!iso) return null;
	const dt = DateTime.fromISO(iso);
	if (!dt.isValid) return null;
	return dt.toFormat('yyyy-MM-dd, HH:mm');
};

export const getSchemeLabel = (scheme: string | null | undefined): string => {
	if (!scheme) return '—';
	return SCHEME_LABELS[scheme] ?? scheme.replace(/_/g, ' ').toUpperCase();
};

export const getReportingPeriodLabel = (row: TEmVatCorrectionsImportRow): string => {
	if (row.correction_peeriod) return String(row.correction_peeriod);
	const built = correctionPeriodLabel(row);
	return built || '—';
};
